import { DocumentRequiredPreview } from '@/components/screens/lawyerapp';
import useModalPreviewPage from '@/hooks/useModalPreviewPage';
import { DocumentRequiredI } from '@/interfaces';
import * as React from 'react';

interface Props {
	caseName: string;
	modalTitle: string;
	isCaseReadOnly: boolean;
	documentList: DocumentRequiredI[];
	open: boolean;
	content: string;
	isStepApproved?: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	handleApprove: () => void;
}

export const ModalRequestDocumentPreview: React.FC<Props> = ({
	caseName,
	modalTitle,
	isCaseReadOnly,
	documentList,
	open,
	content,
	isStepApproved,
	setOpen,
	handleApprove,
}) => {
	const { ModalPreviewPage, hidePreviewPage, showPreviewPage } =
		useModalPreviewPage();

	React.useEffect(() => {
		if (open) {
			showPreviewPage();
		} else {
			hidePreviewPage();
			// setOpen(false);
		}
	}, [open]);

	const handleClose = () => {
		hidePreviewPage();
		setOpen(false);
	};

	return (
		<ModalPreviewPage
			handleClickApprove={handleApprove}
			handleClickBack={handleClose}
			handleClickEdit={handleClose}
			onClose={handleClose}
			backCustomLabel="Back to edit"
			title={modalTitle}
			hideApproveButton={isStepApproved || isCaseReadOnly}
			approveCustomLabel="Request Document"
			hideEditButton={true}
			hideTitle={true}
		>
			<DocumentRequiredPreview
				caseName={caseName}
				content={content}
				documentList={documentList || []}
			/>
		</ModalPreviewPage>
	);
};
